import angular from 'angular';

const MAX_TRIES = 5;
const TRY_INTERVAL = 100;

function isChrome() {
  return navigator.userAgent.match(/chrome/i) && !navigator.userAgent.match(/edge/i);
}

function requiredDirective($interval, $log) {

  function linkFn(scope, elem, attrs, ngModel) {
    if (!ngModel) {
      // no ngModel, nothing to do!
      return;
    }
    const originalValidator = ngModel.$validators.required;


    // try validating until
    let tries = 0;
    const timer = $interval(() => {
      tries += 1;
      if (tries > MAX_TRIES) {
        $interval.cancel(timer);
      }
      ngModel.$validate();
    }, TRY_INTERVAL);

    function validator(modelValue, viewValue) {

      if (isChrome() && elem[0].matches('input[type=password]:-webkit-autofill')) {
        $log.info('bypassing required validator because of Chrome auto-filling');
        $interval.cancel(timer);
        return true;
      }
      return originalValidator(modelValue, viewValue);
    }

    ngModel.$validators.required = validator;
  }

  return {
    priority: 100,
    require: '?ngModel',
    link: linkFn,
  };
}

function mdInputContainerDirective($interval) {

  function linkFn($scope, elem) {
    if (isChrome()) {
      let tries = 0;
      const timer = $interval(() => {
        tries += 1;
        if (tries > MAX_TRIES) {
          $interval.cancel(timer);
        }
        if (elem[0].querySelector('input[type=password]:-webkit-autofill')) {
          elem.addClass('md-input-has-value');
          $interval.cancel(timer);
        }
      }, TRY_INTERVAL);
    }
  }

  return {
    restrict: 'E',
    link: linkFn,
  };
}

/**
* element.matches() pollyfill
*/

function matchesFn(ElementPrototype) {
  ElementPrototype.matches = ElementPrototype.matchesSelector ||
  ElementPrototype.mozMatchesSelector ||
  ElementPrototype.msMatchesSelector ||
  ElementPrototype.oMatchesSelector ||
  ElementPrototype.webkitMatchesSelector ||
  function f(selector) {
    const node = this;
    const nodes = (node.parentNode || node.document).querySelectorAll(selector);
    let i = -1;

    /* eslint no-plusplus: 0 */
    while (nodes[++i] && nodes[i] !== node);

    return !!nodes[i];
  };
}

if (Element) {
  matchesFn(Element.prototype);
}

/**
* @ngdoc module
* @name chrome-autofill-fix
* @module chrome-autofill-fix
* @description
* A tiny fix for chrome problems regarding auto-filled passwords
*
*/
const chromeAutofillFixModule = angular.module('chrome-autofill-fix', [])
/**
* @ngdoc directive
* @module chrome-autofill-fix
* @name mdInputContainer
* Prevents floating label collapsing in [angular-material](https://material.angularjs.org/latest/demo/input) inputs
*
*/
.directive('mdInputContainer', ['$interval', mdInputContainerDirective])
/**
* @ngdoc directive
* @module chrome-autofill-fix
* @name required
* Overrides the default `required` validator to take Chrome auto-filling into account
*/
.directive('required', ['$interval', '$log', requiredDirective]);

export default chromeAutofillFixModule;



// WEBPACK FOOTER //
// ./src/modules/fixes/chrome-autofill-fix/chrome-autofill-fix.module.js